import { normalizeSymbolType } from "../components/flowSymbol";

// Početak i kraj su samo grafički elementi dijagrama toka — za njih je
// obavezan jedino izbor simbola.
export const GRAPHIC_ONLY_SYMBOL_TYPES = ["start", "end"];

const REQUIRED_ROW_FIELDS = [
  "name",
  "description",
  "activities_designations",
  "symbol_type",
];

// Za ostale tipove provera ostaje ista kao ranije (prazna vrednost = greška).
export const validateProcedureRow = (row) => {
  if (!row) return undefined;

  const fields = GRAPHIC_ONLY_SYMBOL_TYPES.includes(
    normalizeSymbolType(row.symbol_type)
  )
    ? ["symbol_type"]
    : REQUIRED_ROW_FIELDS;

  const errors = {};
  fields.forEach((field) => {
    if (!row[field]) {
      errors[field] = true;
    }
  });

  return Object.keys(errors).length ? errors : undefined;
};
